import React, { useState, useEffect, Component } from 'react';
import { ref, set, onValue, query, orderByChild } from "firebase/database";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import UserLogin from '../components/UserLogin';

function TextLinkExample({ getUser, database }) {   
    const [tempUser, setTempUser] = useState([]);
    const [userData, setUserData] = useState([]);
    //const [userQuery, setUserQuery] = useState([]);

    useEffect(() => {
        getUser(tempUser);
        if (tempUser?.uid) {
            const userQuery = ref(database, '/users/' + tempUser.uid + '/');
            onValue(userQuery, (snapshot) => {
                setUserData(snapshot.val());

            });
        }
    }, [tempUser]);

    return (
        <Navbar className="bg-body-tertiary" expand="xl" bg="transparent" variant="dark">
            <Container>
                <Navbar.Toggle />
                <Navbar.Collapse className="justify-content-end" >
                    <Navbar.Text>
                        <UserLogin getGetUser={setTempUser} />
                    </Navbar.Text>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default TextLinkExample;